import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import {
  Col,
  Row,
  Form,
  Button,
  FormGroup,
  Label,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Spinner,
} from "reactstrap";
import axios from "axios";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import Header from "../../../layout/Header/Header";

import { v4 as uuidv4 } from "uuid";

import moment from "moment";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
    },
  },
  button: {
    margin: theme.spacing(1),
  },
}));

function TraspasosSalidaCreate() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_ARTICULOS = process.env.REACT_APP_URL_ARTICULOS;
  const URL_COLORES = process.env.REACT_APP_URL_COLORES;
  const URL_TALLAS = process.env.REACT_APP_URL_TALLAS;
  const URL_TRASPASOS_SALIDA = process.env.REACT_APP_URL_TRASPASOS_SALIDA;
  const URL_ARTICULOS_TS = process.env.REACT_APP_URL_ARTICULOS_TS;
  // TK8 — entrada automática
  const URL_TRASPASOS_ENTRADA = process.env.REACT_APP_URL_TRASPASOS_ENTRADA;
  const URL_ARTICULOS_TE = process.env.REACT_APP_URL_ARTICULOS_TE;
  const URL_AREAS = process.env.REACT_APP_URL_AREAS;
  const AREAS_GENERAL = process.env.REACT_APP_AREAS_GENERAL;
  const URL_INVENTARIOS = process.env.REACT_APP_URL_INVENTARIOS;

  let date = new Date();
  let hoy = moment(date).format("YYYY-MM-DD");

  const [inventarios, setInventarios] = useState([]);
  const [fecha, setFecha] = useState(hoy);
  const [areas, setAreas] = useState([]);
  const [areaSalida, setAreaSalida] = useState("");
  const [areaDestino, setAreaDestino] = useState("");
  const [observaciones, setObservaciones] = useState("NA");
  const [total, setTotal] = useState(0);
  const [articulosUnicos, setArticulosUnicos] = useState([]);
  const [articulos, setArticulos] = useState([]);

  const [coloresUnicos, setColoresUnicos] = useState([]);
  const [tallasUnicos, setTallasUnicos] = useState([]);

  const [modalProgreso, setModalProgreso] = useState(false);
  const toggleProgreso = () => setModalProgreso(!modalProgreso);

  const classes = useStyles();
  const [inputFields, setInputFields] = useState([
    {
      id: uuidv4(),
      articulos: "",
      cantidad: 0,
      idInv: "",
      colores: "",
      arrayColoresArticulo: [],
      tallas: "",
      arrayTallasArticulo: [],
      tc: [],
      totalArt: 0,
    },
  ]);

  const [validaBoton, setValidaBoton] = useState(true);

  useEffect(() => {
    axios
      .get(URL_AREAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allAreas = res.data;
        setAreas(allAreas);
      })
      .catch((err) => {
        console.log(err);
      });
    axios
      .get(URL_ARTICULOS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allArticulos = res.data;
        setArticulos(allArticulos);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const saveTraspasosSalida = async (event) => {
    event.preventDefault();
    if (areaDestino != "" && areaSalida != "") {
      setValidaBoton(false);
      toggleProgreso();

      const headers = {
        Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
      };

      try {
        // 1) Traspaso de SALIDA
        const { data: salida } = await axios.post(
          URL_TRASPASOS_SALIDA,
          { fecha, areaSalida, areaDestino, observaciones, user: user.id, total },
          { headers }
        );

        // TK8 (2026-06) — 2) Traspaso de ENTRADA automático, ligado a la salida
        const { data: entrada } = await axios.post(
          URL_TRASPASOS_ENTRADA,
          {
            fecha,
            traspasosSalida: salida._id,
            observaciones,
            user: user.id,
            total,
          },
          { headers }
        );

        // 3) Por cada combo: ArticulosTS (resta origen) + ArticulosTE (suma destino).
        //    Los controllers ya hacen el inc/dec de inventario (L57), así que con
        //    crear ambos el inventario se mueve del almacén de salida al destino.
        const ops = [];
        inputFields.forEach((a) => {
          if (a.articulos != "") {
            a.tc.forEach((b) => {
              if (b.cantidad > 0) {
                ops.push(
                  axios.post(
                    URL_ARTICULOS_TS,
                    {
                      traspasosSalida: salida._id,
                      articulos: a.articulos,
                      cantidad: parseFloat(b.cantidad),
                      inventarios: b.idInv,
                      colores: b.colores,
                      tallas: b.tallas,
                    },
                    { headers }
                  )
                );
                // TK8 — entrada automática del mismo combo (suma en el destino)
                ops.push(
                  axios.post(
                    URL_ARTICULOS_TE,
                    {
                      traspasosEntrada: entrada._id,
                      articulos: a.articulos,
                      cantidad: parseFloat(b.cantidad),
                      areaDestino,
                      colores: b.colores,
                      tallas: b.tallas,
                    },
                    { headers }
                  )
                );
              }
            });
          }
        });
        await Promise.all(ops);

        // TK8 — 4) marcar la salida como recibida (la entrada ya se generó)
        await axios.patch(
          `${URL_TRASPASOS_SALIDA}/${salida._id}`,
          { recibida: "Si" },
          { headers }
        );

        await axios.post(
          URL_LOGS,
          {
            tipo: "Crear Traspaso Salida",
            detalle: `${areaSalida} ${total}`,
            user: user.id,
          },
          { headers }
        );

        Swal.fire("Good job!", "Traspaso creado con entrada automática", "success");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
        });
        console.log(error);
        setValidaBoton(true);
      }
    } else {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Falta seleccionar el area!",
      });
    }
  };
  const handleAddFields = () => {
    setInputFields([
      ...inputFields,
      {
        id: uuidv4(),
        articulos: "",
        cantidad: 0,
        idInv: "",
        colores: "",
        arrayColoresArticulo: [],
        tallas: "",
        arrayTallasArticulo: [],
        tc: [],
        totalArt: 0,
      },
    ]);
  };

  const handleRemoveFields = (id) => {
    const values = [...inputFields];
    values.splice(
      values.findIndex((value) => value.id === id),
      1
    );
    setInputFields(values);
    let cant = values.map((c) => parseFloat(c.cantidad));
    let TC = cant.reduce((t, total, index) => t + total, 0);
    setTotal(TC);
  };

  const handleChangeInputCantidad = (id, colores, tallas, idInv, event) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i.tc.map((a) => {
          if (a.idInv == idInv) {
            if (a.cantInv >= event.target.value) {
              a.cantidad = event.target.value;
            } else {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "La cantidad excede el inventario!",
              });
            }
          }
        });

        let can = i.tc.map((c) => parseFloat(c.cantidad));
        let TC = can.reduce((t, total, index) => t + total, 0);

        i.totalArt = TC;
      }
      return i;
    });
    setInputFields(newInputFields);

    ActualizaTotales();
  };

  function BuscaArticulo(id, event) {
    articulos.map((a) => {
      if (a._id == event.target.value) {
        let idArticulo = a._id;
        let coloresArticulo = a.colores;
        let tallasArticulo = a.tallas;
        handleChangeInputArticulo(
          id,
          idArticulo,
          coloresArticulo,
          tallasArticulo
        );
      }
    });
  }

  const handleChangeInputArticulo = (
    id,
    idArticulo,
    coloresArticulo,
    tallasArticulo
  ) => {
    const newInputFields2 = [];

    // L69 + fix (2026-07) — Construimos los combos SIEMPRE desde el inventario
    // REAL del almacén de salida (lo que físicamente hay en stock). El catálogo
    // del artículo puede no coincidir con el inventario (colores/tallas que se
    // cambiaron después), y un traspaso solo mueve lo que existe. Antes esto
    // solo se hacía si el catálogo venía vacío, por eso a veces no salía el
    // inventario aunque sí lo hubiera.
    const colorMap = {};
    const tallaMap = {};
    (inventarios || []).forEach((b) => {
      if (String(b.idArticulo) !== String(idArticulo)) return;
      if (b.idColor && !colorMap[b.idColor]) {
        colorMap[b.idColor] = { _id: b.idColor, name: b.color || "" };
      }
      if (b.idTalla && !tallaMap[b.idTalla]) {
        tallaMap[b.idTalla] = {
          _id: b.idTalla,
          name: b.talla || "",
          // variante del inventario para mostrar "talla + variante"
          variantesTallas: b.variante ? [{ name: b.variante }] : [],
        };
      }
    });
    let coloresArray = Object.values(colorMap);
    let tallasArray = Object.values(tallaMap);

    // Fallback al catálogo del artículo solo si el inventario no trajo nada.
    if (!coloresArray.length) coloresArray = Object.values(coloresArticulo || {});
    if (!tallasArray.length) tallasArray = Object.values(tallasArticulo || {});

    // fix — ordenar las tallas con el orden canónico del sistema (como en todos lados)
    const ordenTallas = ["2XCH","XCH","EXTRA CHICA","CHICA","CH","M","MEDIANA","GRANDE","G","EXTRA GRANDE","XG","2XG","XXG","3XG","XXXG","4XG","XXXXG","5XG","XXXXXG","ESP","VARIOS","2","4","6","8","9","10","11","12","13","14","15","16","17","18","19","20","21","22","23","24","25","26","27","28","29","30","31","32","33","34","35","36","37","38","39","40","41","42","43","44","45","46","47","48","49","50","51","52","53","54","55","56"];
    const idxTalla = (n) => {
      const i = ordenTallas.indexOf(String(n || "").trim().toUpperCase());
      return i === -1 ? 999 : i;
    };
    tallasArray = tallasArray
      .slice()
      .sort((a, b) => idxTalla(a?.name) - idxTalla(b?.name));

    // L56 (2026-06) — Cada Talla doc ya es su propia variante en la colección
    // Tallas; solo usamos su name y le sufijamos el nombre de la variante para
    // diferenciar visualmente. NO se crean filas extra (eso causaba el doble
    // descuento porque dos filas compartían el mismo Talla _id).
    coloresArray.map((a) => {
      tallasArray.map((b) => {
        const varianteName = b.variantesTallas?.[0]?.name || "";
        const tallaLabel = varianteName ? `${b.name} ${varianteName}` : b.name;
        newInputFields2.push({
          colores: a._id,
          colorNombre: a.name,
          tallas: b._id,
          tallaNombre: tallaLabel,
          cantidad: 0,
          cantInv: 0,
          idInv: "",
        });
      });
    });

    // L54 / L55 (2026-06) — Mapea cantInv sumando TODOS los inventarios que
    // hagan match con el combo (puede haber varios docs por articulo+color+talla
    // en la misma área).
    newInputFields2.map((a) => {
      let totalCombo = 0;
      let lastInvId = "";
      inventarios.forEach((b) => {
        if (
          idArticulo == b.idArticulo &&
          a.colores == b.idColor &&
          a.tallas == b.idTalla
        ) {
          totalCombo += Number(b.cantidad) || 0;
          lastInvId = b._id;
        }
      });
      a.cantInv = totalCombo;
      a.idInv = lastInvId;
      return a;
    });

    // L70 (2026-06) — ocultar combos sin inventario (cantInv <= 0)
    const tcFiltrado = newInputFields2.filter((a) => Number(a.cantInv) > 0);

    // Solo mostrar colores que tengan al menos una talla con inventario
    const colorIdsConInv = new Set(tcFiltrado.map((a) => String(a.colores)));
    const coloresFiltrados = coloresArray.filter((c) =>
      colorIdsConInv.has(String(c._id))
    );

    // Solo mostrar tallas que tengan al menos un color con inventario
    const tallaIdsConInv = new Set(tcFiltrado.map((a) => String(a.tallas)));
    const tallasFiltradas = tallasArray.filter((t) =>
      tallaIdsConInv.has(String(t._id))
    );

    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i.articulos = idArticulo;
        // L69 / L70 (2026-06) — arrays filtrados a lo que sí tiene inventario
        i.arrayColoresArticulo = coloresFiltrados;
        i.arrayTallasArticulo = tallasFiltradas;
        i.tc = tcFiltrado;
      }
      return i;
    });
    setInputFields(newInputFields);

    ActualizaTotales();
  };


  function ActualizaTotales() {
    let cant = inputFields.map((c) => parseFloat(c.totalArt));
    let TC = cant.reduce((t, total, index) => t + total, 0);
    setTotal(TC);
  }

  function jalaAlmacenSalida(e) {
    setAreaSalida(e);
    toggleProgreso();

    axios
      .get(`${URL_INVENTARIOS}/traspasos/${e}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allInventarios = res.data;
        setInventarios(allInventarios);
      })
      .catch((err) => {
        console.log(err);
      });

    setTimeout(() => {
      setModalProgreso(false);
    }, 3000);

    setInputFields([
      {
        id: uuidv4(),
        articulos: "",
        cantidad: 0,
        idInv: "",
        colores: "",
        arrayColoresArticulo: [],
        tallas: "",
        arrayTallasArticulo: [],
        tc: [],
        totalArt: 0,
      },
    ]);
  }

  function jalaAlmacenDestino(e) {
    setAreaDestino(e);
    toggleProgreso();

    setTimeout(() => {
      setModalProgreso(false);
    }, 3000);

    setInputFields([
      {
        id: uuidv4(),
        articulos: "",
        cantidad: 0,
        idInv: "",
        colores: "",
        arrayColoresArticulo: [],
        tallas: "",
        arrayTallasArticulo: [],
        tc: [],
        totalArt: 0,
      },
    ]);
  }

  return (
    <>
      <Header />
      <br />
      <br />
      {user.traspasos_salida_create ? (
        <div className="card container col-12">
          <h3 align="center">Nuevo Traspaso Salida</h3>
          <Form onSubmit={saveTraspasosSalida}>
            <Row>
              <Col md={2}>
                <Label>Fecha</Label>
                <Input
                  type="date"
                  placeholder="Fecha"
                  value={fecha}
                  required
                  disabled
                />
              </Col>
              <Col md={2}>
                <Label className="mr-sm-2">Almacen Salida</Label>
                {user.areas == AREAS_GENERAL ? (
                  <Input
                    className="col-sm-12"
                    type="select"
                    value={areaSalida}
                    required
                    onChange={(e) => {
                      jalaAlmacenSalida(e.target.value);
                    }}
                  >
                    <option value="0">Almacen Salida</option>
                    {areas
                      .sort((a, b) => (a.name > b.name ? 1 : -1))
                      .map((a) => {
                        if (a._id != AREAS_GENERAL) {
                          return <option value={a._id}>{a.name}</option>;
                        }
                      })}
                  </Input>
                ) : (
                  <Input
                    className="col-sm-12"
                    type="select"
                    value={areaSalida}
                    required
                    onChange={(e) => {
                      jalaAlmacenSalida(e.target.value);
                    }}
                  >
                    <option value="0">Almacen Salida</option>
                    {areas
                      .sort((a, b) => (a.name > b.name ? 1 : -1))
                      .map((a) => {
                        if (user.areas == a._id) {
                          return <option value={a._id}>{a.name}</option>;
                        }
                      })}
                  </Input>
                )}
              </Col>
              <Col md={2}>
                <Label className="mr-sm-2">Almacen Destino</Label>
                <Input
                  className="col-sm-12"
                  type="select"
                  value={areaDestino}
                  required
                  onChange={(e) => {
                    jalaAlmacenDestino(e.target.value);
                  }}
                >
                  <option value="0">Almacen Destino</option>
                  {areas
                    .sort((a, b) => (a.name > b.name ? 1 : -1))
                    .map((a) => {
                      if (a._id != AREAS_GENERAL) {
                        return <option value={a._id}>{a.name}</option>;
                      }
                    })}
                </Input>
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <Label for="exampleEmail" className="mr-sm-2">
                  Observaciones
                </Label>
                <Input
                  type="textarea"
                  placeholder="Observaciones"
                  value={observaciones}
                  required
                  onChange={(e) => {
                    setObservaciones(e.target.value);
                  }}
                />
              </Col>
              <Col md={4}>
                <h4 id="logoutBoton">TOTALES {total} pzas.</h4>
              </Col>
            </Row>

            {/* Tabla Articulos */}

            <Row>
              <Col md={3}>
                <Label className="mr-sm-2">Modelo</Label>
              </Col>
              <Col md={1}>
                <Label className="mr-sm-2">Piezas</Label>
              </Col>
            </Row>

            {inputFields.map((inputField) => (
              <div key={inputField.id}>
                <Row>
                  <Col md={3}>
                    <Input
                      bsSize="sm"
                      name="articulos"
                      type="select"
                      value={inputField.articulos}
                      required
                      // fix — no permitir elegir artículo sin Almacén Salida
                      disabled={!areaSalida}
                      onChange={(event) => {
                        BuscaArticulo(inputField.id, event);
                      }}
                    >
                      <option value="">
                        {!areaSalida
                          ? "Primero elige Almacén Salida"
                          : "Selecciona un Articulo"}
                      </option>
                      {articulos
                        .slice()
                        // fix — ordenar artículos por código (orden natural)
                        .sort((a, b) =>
                          String(a.codigo || "").localeCompare(
                            String(b.codigo || ""),
                            undefined,
                            { numeric: true }
                          )
                        )
                        .map((a) => {
                          return (
                            <option value={a._id}>
                              {a.codigo} {a.descripcion}
                            </option>
                          );
                        })}
                    </Input>
                  </Col>

                  <Col md={1}>
                    <Input
                      bsSize="sm"
                      name="totalArt"
                      type="number"
                      placeholder="Piezas"
                      value={inputField.totalArt}
                      disabled
                    />
                  </Col>

                  <Col>
                    <Button
                      size="sm"
                      className="btn"
                      color="danger"
                      disabled={inputFields.length === 1}
                      onClick={() => handleRemoveFields(inputField.id)}
                      tabindex="-1"
                    >
                      <i class="fas fa-minus"></i>
                    </Button>
                    <Button
                      size="sm"
                      className="btn"
                      color="info"
                      onClick={handleAddFields}
                      tabindex="-1"
                    >
                      <i class="fas fa-plus"></i>
                    </Button>
                  </Col>
                </Row>

                {inputField.arrayColoresArticulo.map((col) => {
                  return (
                    <>
                      {/* L55 (2026-06) — Row compacto sin márgenes verticales */}
                      <Row style={{ marginTop: 0, marginBottom: 4 }}>
                        <Col md={9} className="tallas" style={{ alignItems: "flex-start" }}>
                          <Col md={1} style={{ paddingTop: 14 }}>
                            <Label style={{ fontSize: "12px", fontWeight: "bold" }}>{col.name}</Label>
                          </Col>
                          {inputField.tc.map((a) => {
                            if (a.colores == col._id) {
                              return (
                                // L55 — Talla+variante / Input / Inv apilados y pegados
                                <Col
                                  md={1}
                                  style={{
                                    padding: "0 2px",
                                    minWidth: "68px",
                                    lineHeight: 1,
                                  }}
                                >
                                  <Label
                                    style={{
                                      fontSize: "11px",
                                      fontWeight: "bold",
                                      marginBottom: "1px",
                                      display: "block",
                                      lineHeight: "1.1",
                                    }}
                                  >
                                    {a.tallaNombre}
                                  </Label>
                                  <Input
                                    bsSize="sm"
                                    name="cantidad"
                                    type="number"
                                    value={a.cantidad}
                                    required
                                    onChange={(event) =>
                                      handleChangeInputCantidad(
                                        inputField.id,
                                        a.colores,
                                        a.tallas,
                                        a.idInv,
                                        event
                                      )
                                    }
                                  />
                                  <small
                                    style={{
                                      color:
                                        a.cantInv > 0 ? "#6b7280" : "#dc2626",
                                      fontSize: "10px",
                                      display: "block",
                                      marginTop: "0px",
                                      lineHeight: "1",
                                      whiteSpace: "nowrap",
                                    }}
                                  >
                                    Inv: {a.cantInv || 0}
                                  </small>
                                </Col>
                              );
                            }
                          })}
                        </Col>
                      </Row>
                    </>
                  );
                })}
              </div>
            ))}
            <Row>
              <Col md={10}>
                <h4 id="logoutBoton">TOTALES {total} pzas.</h4>
              </Col>
            </Row>
            {/* Termina Tabla Articulos */}

            <br />
            {validaBoton ? (
              <Button type="submit" className="btn btn-success">
                Guardar
              </Button>
            ) : (
              <Button type="submit" className="btn btn-success" disabled>
                Guardar
              </Button>
            )}
            <Button
              href="/ListadoTraspasosSalida"
              className="btn btn-danger"
              id="botonListado"
            >
              Regresar
            </Button>
          </Form>
          <br />
          <Modal size="sm" isOpen={modalProgreso} toggle={toggleProgreso}>
            <ModalHeader toggle={toggleProgreso}>
              <h4>Progreso</h4>
            </ModalHeader>
            <ModalBody>
              <h4>
                {" "}
                Este proceso puede tardar varios segundos.
                <br />
                Por favor no cierre ni refresque su navegador.
              </h4>
              <br />
              <div className="progreso">
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
              </div>
            </ModalBody>
          </Modal>
        </div>
      ) : undefined}
    </>
  );
}

export default TraspasosSalidaCreate;
